module.exports = __webpack_public_path__ + "img/3.8afb4c4c.jpg";